// Export configuration parameters for all of the process environmental variables
export const config = {
    openApiUrl: process.env.REACT_APP_OPEN_API,
    // openApiUrl: 'http://localhost:7071/api',
    restrictedApiUrl: process.env.REACT_APP_RESTRICTED_API,
    insights_key: process.env.REACT_APP_INSIGHTS_KEY,
    ownerOrgEmail: process.env.REACT_APP_OWNER_ORG_EMAIL,
    auth: {
        authority: process.env.REACT_APP_TENANTLOGIN,
        clientId: process.env.REACT_APP_CLIENTID,
        scopes: process.env.REACT_APP_AAD_CLIENT_SCOPE.split(','),
        redirectUri: `${window.location.origin}/callback`,
    },
    version: process.env.REACT_APP_VERSION,
};

export default config;
